<template>
    <div>
       <b-tabs v-model="tabIndex">
            <b-tab title="Pagar">
                <template v-if="tabIndex == 0">
                    <pagar></pagar>                    
                </template>
            </b-tab>
            <b-tab   title="Estado de cuenta">
                <template v-if="tabIndex == 1">
                    <estado :datos="datos"></estado>              
                </template>
            </b-tab>
            <!-- <b-tab title="Reporte de pago">
                <template v-if="tabIndex == 2">
                    <pagos></pagos> 
                </template>
            </b-tab>
            <b-tab title="Pendiente de pagos">
                <template v-if="tabIndex == 3">
                    <pendientes></pendientes>
                </template>
            </b-tab> -->
        </b-tabs>
    </div>
</template>
<script>
import Pagar from '@/components/gestion/CuentasPagar'
import Estado from '@/components/gestion/EstadoCuentaPagos'
// import Pagos from '@/components/gestion/ReportePagos'
// import Pendientes from '@/components/gestion/PendientesPago'
export default {   
    name:"PagosCobranza",
    components: {
          Pagar,
          Estado,
        //   Pagos, 
        //   Pendientes
      },
    data() {
        return {
            tabIndex: 0,
            datos: {
                tipo: 1,
                documento: ''
            }
        }
    },
}
</script>
<style lang="stylus" scoped>

</style>